import React, { useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from './TokenChecker';

export default function ConfirmEmailChange() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const token = params.get('token') || '';

  const [status, setStatus] = useState({ type: '', msg: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const confirmChange = async () => {
      if (!token) {
        setStatus({ type: 'error', msg: 'Missing verification token.' });
        return;
      }
      setSubmitting(true);
      setStatus({ type: '', msg: '' });
      try {
        const res = await fetch(`${API_BASE_URL}/api/settings/change-email/confirm/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok) {
          setStatus({ type: 'success', msg: data.message || 'Email updated successfully.' });
        } else {
          setStatus({ type: 'error', msg: data.error || 'Failed to confirm email change.' });
        }
      } catch (_) {
        setStatus({ type: 'error', msg: 'Failed to confirm email change. Try again later.' });
      } finally {
        setSubmitting(false);
      }
    };
    confirmChange();
  }, [token]);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="fixed inset-0 bg-slate-950/40 backdrop-blur-sm"></div>
      <div className="relative z-10 w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="relative px-6 py-5 text-white">
          <div className="absolute inset-0 bg-gradient-to-r from-[#10A7F3] via-[#38BDF8] to-[#10F3D6]"></div>
          <div className="relative">
            <p className="text-xs font-semibold uppercase tracking-widest text-white/80">Account</p>
            <h2 className="text-lg font-semibold">Email change status</h2>
          </div>
        </div>
        <div className="px-6 py-5">
          {status.msg && (
            <div className={`mb-4 px-4 py-3 rounded ${status.type === 'error' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>
              {status.msg}
            </div>
          )}
          {!status.msg && (
            <div className="mb-4 px-4 py-3 rounded bg-blue-50 text-blue-700 border border-blue-200">
              {submitting ? 'Verifying your email change…' : 'Preparing confirmation…'}
            </div>
          )}
          {status.type === 'success' && (
            <p className="text-sm text-slate-600">
              Your email has successfully changed.
            </p>
          )}
          <div className="mt-6 flex items-center justify-end gap-3">
            <a
              href="/login"
              className="rounded-lg bg-gradient-to-r from-[#10A7F3] to-[#10F3D6] px-4 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-90"
            >
              Back to Flowman
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
